import { useState } from "react";
import { ConfirmModal } from "../../../../components";
import { Link } from "react-router-dom";
import styles from "../index.module.scss";

interface IProductProps {
  title: string;
  price: number;
  desc: string;
  img: string;
}
const Product = ({ title, img, desc, price }: IProductProps) => {
  const [visible, setVisible] = useState(false);
  const handleDelete = () => {
    setVisible(true);
  };

  const handleClose = () => {
    setVisible(false);
  };
  return (
    <>
      <tr>
        <td className={styles.procedure}>{title}</td>
        <td>{price}</td>
        <td>{desc}</td>
        <td>
          <img src={img} alt="" />
        </td>
        <td className={styles.action}>
          <Link to="">
            <button>Изменить</button>
          </Link>
          <button onClick={handleDelete}>Удалить</button>
        </td>
      </tr>
      <ConfirmModal
        visible={visible}
        handleClose={handleClose}
        deletionName={title}
      />
    </>
  );
};

export default Product;
